/* eslint-disable */
import { defineStore } from 'pinia';
import _ from 'lodash';
import { v5 as uuidv5 } from 'uuid';
import { useLanguagesStore } from './languages';
import { useInitializeStore } from './initialize';
import axios from 'axios';
import { useLiveCourtStore } from './live_court';

export const useVirtualCourtStore = defineStore('virtualCourt', {
	state: () => ({
		selected_fixture: null,
		selected_fixture_mobile: null,
		fixture_in_queue: null,
		auth: {},
		token: null
	}),
	getters: {
		selectedFixtureId(state) {
			if (!state.selected_fixture) return null;
			return state.selected_fixture.virtual_live_id;
		},
		selectedFixture(state) {
			if (!state.selected_fixture) return null;
			return state.selected_fixture;
		},
		getVirtualCourtLanguageLocale() {
			let language = useLanguagesStore().selectedLanguage;
			return language.locale;
		},
		isSportEligible(state) {
			if (!state.selectedFixture) return false;

			let eligible_sport_ids = [1, 3, 2, 8, 10, 5, 4, 6, 22, 9, 11];
			if (eligible_sport_ids.includes(state.selectedFixture.sport_id)) return true;

			return false;
		},
		mustAuthenticateVirtualCourt() {
			if (!process.env.VUE_APP_VIRTUAL_COURT_AUTH) return false;
			if (process.env.VUE_APP_VIRTUAL_COURT_AUTH == 'false') return false;

			return true;
		},
		fixtureInQueue(state) {
			return state.fixture_in_queue;
		}
	},
	actions: {
		selectFixtureNew(fixture) {
			this.selected_fixture = fixture;
		},
		selectFixture(fixture) {
			if (this.selected_fixture != null && this.selected_fixture.id == fixture.id) return;

			let targetOrigin = process.env.VUE_APP_VIRTUAL_COURT_URL;
			let fixture_uuid = uuidv5(String(fixture.virtual_live_id), process.env.VUE_APP_VIRTUAL_COURT_NAMESPACE);

			let message_payload = {
				fixture_uuid: fixture_uuid,
				colors: ["#373D46", '#373D46', '#373D46']
			}

			let virtual_live_element = document.getElementsByClassName('virtual-live-frame');

			if (virtual_live_element.length > 0) {
				setTimeout(() => {
					virtual_live_element[0].contentWindow.postMessage(message_payload, targetOrigin);
				}, 100);

				this.selected_fixture = fixture;
			}
		},
		setFixtureInQueue(fixture) {
			this.fixture_in_queue = fixture;

			if (window.innerWidth < 1360) useLiveCourtStore().setActiveCourt('scoreboard');
		},
		emptyVirtualCourt() {
			this.selected_fixture = null;
			// this.fixture_in_queue = null;
		},
		authenticateVirtualCourt() {
			return axios.post(process.env.VUE_APP_API_URL + '/virtual-court/authenticate').then((response) => {
				this.auth = response.data;
				this.auth.update_at_timestamp = response.data.expires_in + useInitializeStore().server_timestamp - 10;
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		refreshTokenVirtualCourt() {
			let payload = { refresh_token: this.auth.refresh_token };

			return axios.post(process.env.VUE_APP_API_URL + '/virtual-court/refresh', payload).then((response) => {
				this.auth = response.data;
				this.auth.update_at_timestamp = response.data.expires_in + useInitializeStore().server_timestamp - 10;
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})

		},
		setToken(token) {
			this.token = token;
		}
	},
})